import React, { useState, useEffect, useRef, useCallback } from 'react';
import ChatMessage from './components/ChatMessage';
import { PERSONAS } from './personas';

//여기서 추가
///home/ladmin/docker/sorabot/frontend/sorabot-project/src/personas.js

// 메인 App 컴포넌트
const App = () => {
    const [selectedPersona, setSelectedPersona] = useState("sorabot"); // 기본값 지정
    // 캐릭터별 독립된 세션 관리
    const [sessionMessages, setSessionMessages] = useState({
        sorabot: [],
        chasera: [],
        leedaon: [],
        yoonmiru: []
    });

    // 현재 입력 필드의 값
    const [currentInput, setCurrentInput] = useState('');
    // 선택된 LLM 모델
    const [selectedModel, setSelectedModel] = useState('gemma-4-31B-it'); // 기본 모델 설정
    // const [selectedModel, setSelectedModel] = useState('');
    // vLLM에서 사용 가능한 모델 목록
    const [availableModels, setAvailableModels] = useState([]);
    // 메시지 스크롤을 위한 참조
    const messagesEndRef = useRef(null);
    // 로딩 상태 (API 호출 중인지)
    const [isLoading, setIsLoading] = useState(false);
    // 오류 메시지 상태
    const [error, setError] = useState('');

    // 현재 선택된 캐릭터의 메시지만 가져오기
    const currentMessages = sessionMessages[selectedPersona] || [];

    // 현재 캐릭터 세션에만 메시지 추가하는 함수
    const addMessageToCurrentSession = (newMessage) => {
        setSessionMessages(prev => ({
            ...prev,
            [selectedPersona]: [...prev[selectedPersona], newMessage]
        }));
    };

    // 메시지가 업데이트될 때마다 스크롤을 맨 아래로 이동
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [currentMessages]);

    // 사용 가능한 vLLM 모델 목록을 백엔드에서 가져오는 함수
    // useCallback을 사용하여 함수가 불필요하게 재생성되지 않도록 최적화
    const fetchAvailableModels = useCallback(async () => {
        try {
            // FastAPI 백엔드 URL. 로컬 PC에서 공인 IP를 통해 접근하도록 설정.
            // 이 주소는 라우터/방화벽에서 192.168.0.66:8000으로 포트 포워딩 되어 있어야 합니다.
            const BACKEND_BASE_URL = '/api'; // 공인 IP로 변경

            const response = await fetch(`${BACKEND_BASE_URL}/models`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setAvailableModels(data.models);
            if (data.models.length > 0 && !data.models.includes(selectedModel)) {
                setSelectedModel(data.models[0]); // 첫 번째 모델을 기본으로 선택
            }
        } catch (error) {
            console.error("사용 가능한 모델을 가져오는 중 오류 발생:", error);
            setError("vLLM 모델을 가져올 수 없습니다. 백엔드와 vLLM 연결을 확인하세요.");
        }
    }, [selectedModel]); // selectedModel이 변경될 때 함수 재생성

    // 컴포넌트 마운트 시 사용 가능한 모델 목록을 가져옴
    useEffect(() => {
        fetchAvailableModels();
    }, [fetchAvailableModels]); // fetchAvailableModels 함수를 의존성 배열에 추가

    useEffect(() => {
        // 캐릭터 변경 시 해당 세션이 비어있으면 캐릭터 이미지 표시
        if (selectedPersona && currentMessages.length === 0) {
            // 성격 변경 시 채팅창에 캐릭터 이미지 표시
            const imageMessage = {
                sender: 'character-image',
                text: '', // 텍스트는 비워둠
                persona: selectedPersona,
                timestamp: Date.now()
            };
            addMessageToCurrentSession(imageMessage); 
        }
    }, [selectedPersona]);
    // 메시지 전송 핸들러
    const sendMessage = async () => {
        if (!currentInput.trim() || isLoading) return; // 입력이 없거나 로딩 중이면 전송하지 않음

        const userMessage = { sender: 'user', text: currentInput };
        addMessageToCurrentSession(userMessage);
        setCurrentInput(''); // 입력 필드 초기화
        setIsLoading(true); // 로딩 시작
        setError(''); // 오류 메시지 초기화

        try {
            // 백엔드 기본 URL 설정 (위에 정의된 BACKEND_BASE_URL 재사용)
            const BACKEND_BASE_URL = '/api';

            const response = await fetch(`${BACKEND_BASE_URL}/chat`, { // FastAPI 백엔드 URL
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    model: selectedModel, // 선택된 모델 전송
                    prompt: currentInput,
                    // history: currentMessages.map(msg => ({ // 변경된 부분
                    //     role: msg.sender === 'user' ? 'user' : 'assistant',
                    //     content: msg.text
                    // })),
					// vLLM이 뻗지 않도록, 내용이 없는 'character-image'는 전송 목록에서 강제로 빼버립니다!
                    history: currentMessages
                        .filter(msg => msg.sender !== 'character-image') 
                        .map(msg => ({
                            role: msg.sender === 'user' ? 'user' : 'assistant',
                            content: msg.text
                        })),
		    persona: selectedPersona
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const botMessage = { sender: 'bot', text: data.response };
            addMessageToCurrentSession(botMessage);
        } catch (error) {
            console.error("메시지 전송 중 오류 발생:", error);
            setError("메시지 전송에 실패했습니다. 백엔드 또는 vLLM 연결을 확인하세요.");
            // 오류 발생 시 사용자 메시지 제거 또는 오류 메시지 추가 (선택 사항)
            setSessionMessages(prev => ({ // 변경된 부분
                ...prev,
                [selectedPersona]: prev[selectedPersona].slice(0, -1)
            }));
        } finally {
            setIsLoading(false); // 로딩 종료
        }
    };

    // 엔터 키 입력 시 메시지 전송
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) { // Shift+Enter는 줄바꿈 허용
            e.preventDefault(); // 기본 엔터 동작(줄바꿈) 방지
            sendMessage();
        }
    };

return (
    // 전체 레이아웃 컨테이너
    <div className="flex flex-col h-dvh bg-gray-100 font-sans antialiased">
        {/* 상단 헤더 */}
        <header className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 shadow-md text-center text-2xl font-bold rounded-b-xl">
            소라봇
        {/* --- 드롭다운 메뉴 START --- */}
        <div className="flex flex-col items-center mt-4 gap-0">
          <div className="flex items-center gap-2">
            <label htmlFor="persona-select" className="text-sm font-semibold">
              👉 성격 선택:
            </label>
            <select
              id="persona-select"
              value={selectedPersona}
              onChange={e => setSelectedPersona(e.target.value)}
              className="px-3 py-1 border border-gray-300 rounded-lg text-sm bg-white text-gray-800 focus:outline-none"
            >
              {Object.entries(PERSONAS).map(([key, val]) => (
                <option key={key} value={key}>{val.name}</option>
              ))}
            </select>
	    {/* 캐릭터 이미지 추가 */}
	    <img
	      src={PERSONAS[selectedPersona].chatIcon}
 	     alt={`${PERSONAS[selectedPersona].name} 아바타`}
	      className="w-8 h-8 rounded-full object-cover border-2 border-white shadow-sm"
	    />
          </div>
          <span className="text-xs text-blue-100 mt-1">
            {PERSONAS[selectedPersona].description}
          </span>
        </div>
        {/* --- 드롭다운 메뉴 END --- */}
        </header>

        {/* 메인 채팅 영역 */}
        <div className="flex flex-1 overflow-hidden justify-center items-stretch pr-1">
            {/* 채팅 대화창 및 입력 영역 */}
            <main className="flex flex-col flex-1 bg-white border border-blue-200 rounded-xl shadow-lg py-4 relative overflow-hidden max-w-4xl w-full min-h-0">

                {/* 메시지 표시 영역 */}
                <div className="flex-1 overflow-y-auto p-2 scrollbar-thumb-blue-300 scrollbar-track-blue-100 scrollbar-thin min-h-0">
                    {currentMessages.length === 0 && (
                        <div className="text-center text-gray-500 mt-10">
                            {/* <p>안녕하세요! 소라봇과 대화를 시작해보세요.</p> */}
                            <p>안녕하세요! {PERSONAS[selectedPersona].name}과 대화를 시작해보세요.</p>
                            <p className="text-sm mt-2">메시지를 입력하고 엔터 키를 누르세요.</p>
                        </div>
                    )}
                    {currentMessages.map((msg, index) => (
                        <div key={index}>
                            {/* 캐릭터 이미지 메시지 타입 - 새로 추가 */}
                            {msg.sender === 'character-image' && (
                                //원본 이미지
                                <div className="flex justify-center mb-4">
                                    <img
                                        src={PERSONAS[msg.persona].avatar}
                                        alt={`${PERSONAS[msg.persona].name} 캐릭터`}
                                        className="max-w-full h-auto"
                                    />
                                </div>
                            )}

                            {/* 기존 ChatMessage 컴포넌트 - 캐릭터 이미지가 아닐 때만 표시 */}
                            {msg.sender !== 'character-image' && (
                                <ChatMessage
                                    messageContent={msg.text}
                                    sender={msg.sender}
                                    persona={selectedPersona}
                                />
                            )}
                        </div>
                    ))}
                    {isLoading && (
                        <div className="flex justify-start mb-4">
                            <div className="p-3 rounded-xl bg-gray-200 text-gray-800 rounded-bl-none shadow-md">
                                <div className="flex items-center">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900 mr-2"></div>
                                    <span>생각 중...</span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div ref={messagesEndRef} /> {/* 스크롤 위치를 위한 빈 div */}
                </div>

                {/* 메시지 입력 영역 (모델 선택 포함) */}
                <div className="mt-4 flex flex-row items-center px-2 py-2 border-t border-gray-200 gap-2"> {/* gap-0 -> gap-2로 변경 */}
                    {/* 모델 선택 드롭다운 */}
                    <div className="w-auto">
                        <select
                            value={selectedModel}
                            onChange={(e) => setSelectedModel(e.target.value)}
                            className="w-20 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-gray-800 flex-shrink-0"
                        >
                            {availableModels.length > 0 ? (
                                availableModels.map((model) => (
                                    <option key={model} value={model}>
                                        {model}
                                    </option>
                                ))
                            ) : (
                                <option value="">모델 로딩 중...</option>
                            )}
                        </select>
                    </div>
                    {/* 텍스트 입력창 */}
                    <textarea
                        value={currentInput}
                        onChange={(e) => setCurrentInput(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="메시지를 입력하세요..."
                        rows="1"
                        className="flex-1 resize-none p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 overflow-hidden max-h-24 bg-gray-50 min-w-0"
                        style={{ overflowY: 'hidden' }} // 입력 시 자동으로 높이 조절
                    />
                    {/* 전송 버튼 */}
                    <button
                        onClick={sendMessage}
                        disabled={isLoading}
                        className={`px-6 py-3 rounded-lg font-bold transition-colors duration-200 shadow-md transform hover:scale-105 active:scale-95 flex-shrink-0 ${
                            isLoading
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700 text-white'
                        }`}
                    >
                        전송
                    </button>
                </div>
                {error && (
                    <p className="text-red-600 text-sm mt-2 p-2 bg-red-100 border border-red-300 rounded-md text-center">
                        {error}
                    </p>
                )}
            </main>
        </div>
        {/* 푸터 */}
        <footer className="bg-gray-800 text-white text-center p-3 text-sm rounded-t-xl mt-4">
            © 2025 소라봇. All rights reserved.
        </footer>
    </div>
);
};

export default App;

